import React from 'react';

/** A component containing an svg image used for close buttons */
const CloseButton = () => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Group</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Close-button"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g
        id="Notification-bar-3"
        transform="translate(-1395.000000, -27.000000)"
        stroke="#037FB0"
        strokeWidth="2"
      >
        <g id="Group-5" transform="translate(1396.000000, 28.000000)">
          <polyline id="Stroke-1-Copy" points="16 0 8 8 0 0" />
          <polyline
            id="Stroke-1-Copy-2"
            transform="translate(8.000000, 12.000000) rotate(180.000000) translate(-8.000000, -12.000000) "
            points="16 8 8 16 0 8"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default CloseButton;
